import { createFileRoute } from "@tanstack/react-router";

import { getInfiniteNewsQueryOptions } from "../../../entities/news/list-query-options";

export const Route = createFileRoute("/_layout-main/news/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.prefetchInfiniteQuery(getInfiniteNewsQueryOptions()),
});
